import styled from 'styled-components';

const BigButton = styled.div`
  background-color: black;
  cursor: pointer;
  opacity: 1;
  height: 35px;
  line-height: 38px;
  text-align: center;
  ${props => (props.width ? `width: ${props.width}` : '')};
  border-radius: 0px;
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  font-size: 15px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: white;

  &:hover {
    background-color: #222222;
  }
`;

export default BigButton;
